<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BCard } from 'bootstrap-vue';

export default{
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {name:'Tatil',key:'Data.summary',thClass:'w-25'},
                {name:'Başlangıç Tarihi',key:'StartDateStr',thClass:'w-25'},
                {name:'Bitiş Tarihi',key:'EndDateStr',thClass:'w-25'},
                {name:'Süre',key:'Duration',thClass:'w-25'},
                {name:'Onaylı',key:'InUse'},
            ],
            buttons:[
                { text:"Onayla",key:"edit",icon:"CheckCircleIcon",variant:"primary",action:this.use },
            ]
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Excuse.PublicHolidayTable(data)
        },
        use(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.Excuse.PublicHolidayUse(item.Data.GeneratedDateId).then(res => {
                this.$result(res)
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        }
    }
}
</script>